import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function navigationReducer(state = initialState.navigation, action) {
    switch(action.type){

        case types.SET_NAVIGATION:
            //debugger;
            //use immutable state with es6's spread operator (...) on existing state and Object.assign to make a deep copy of existing object to create a brand new state
            return Object.assign({},action.navigation);
        default:
            return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/navigationReducer.js
 **/